import { EmpreintesCarboneData } from '@services/interfaces/generated/YSER-v1';
import GraphExporter from '@shared/components/graph-exporter';
import { DecimalTransform } from '@shared/constants';
import { transformUnit } from '@shared/misc/helpers/data';
import { capitalizeFirstLetter } from '@shared/misc/helpers/strings';
import moment from 'moment';
import 'moment/locale/fr';
import { useMemo } from 'react';

type GraphExporterTelProps = {
  data: EmpreintesCarboneData | undefined;
  unitLabel: string;
  unitIndex: number;
};

const GraphExporterTel = ({ data, unitLabel, unitIndex }: GraphExporterTelProps): React.ReactElement => {
  const exportData = useMemo(() => {
    if (!data?.details) return [];

    // Exporter chaque ligne avec marque/modèle
    return data.details.map((item) => {
      const date = new Date(item.dateAchat);
      const fullDate = moment(date).format('MMMM\xa0YYYY');
      const co2Value = transformUnit(item.totalEmpreinteCarbone, 'co2eq', unitIndex, DecimalTransform.Export);
      const co2Unitaire = transformUnit(item.empreinteCarboneUnitaire, 'co2eq', unitIndex, DecimalTransform.Export);

      return {
        date: capitalizeFirstLetter(fullDate),
        marque: item.marque,
        modele: item.modele,
        quantite: item.quantite,
        co2Unitaire: co2Unitaire.value,
        co2Total: co2Value.value,
      };
    });
  }, [data?.details, unitIndex]);

  const headers = [
    { label: 'Date', key: 'date' },
    { label: 'Marque', key: 'marque' },
    { label: 'Modèle', key: 'modele' },
    { label: 'Quantité', key: 'quantite' },
    { label: `CO2 unitaire (${unitLabel})`, key: 'co2Unitaire' },
    { label: `CO2 total (${unitLabel})`, key: 'co2Total' },
  ];

  return <GraphExporter data={exportData} headers={headers} exportType="telephones" />;
};

export default GraphExporterTel;
